// extracted by mini-css-extract-plugin
export default {"wrap":"stats-listing_wrap__gB7+5","panel":"stats-listing_panel__bkZkC","value":"stats-listing_value__OBmk3","label":"stats-listing_label__dyVxc"};